import { render, staticRenderFns } from "./WbsTable.vue?vue&type=template&id=b4d2b38e&scoped=true"
import script from "./WbsTable.vue?vue&type=script&lang=js"
export * from "./WbsTable.vue?vue&type=script&lang=js"
import style0 from "./WbsTable.vue?vue&type=style&index=0&id=b4d2b38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d2b38e",
  null
  
)

export default component.exports